/*
 * La direccion publica de una foto.
 *
 * encodeURI porque los nombres que llegan del panel son los del telefono de
 * quien sube la foto: "WhatsApp Image 2026-09-13 at 18.12.29 (2).jpeg" trae
 * espacios y parentesis. El navegador los arregla solo, pero CloudFront no
 * siempre, y un espacio sin codificar es una foto que no carga.
 */
const ruta = (archivo) => `${process.env.PUBLIC_URL}${encodeURI(archivo)}`;

export default ruta;
